module.exports = __webpack_public_path__ + "img/push-fei-logo.0018aff6.png";